import cookie from 'react-cookies'
import { connectToSocket } from '@/store/actions/socket'
import { SERVER_URL } from '@/constants/socket'
import { ACCESS_TOKEN_COOKIE } from '@/constants/names'

export function reconnectWebSocketAfterAuth(store, token) {
  const accessToken = token || cookie.load(ACCESS_TOKEN_COOKIE)
  if (!accessToken || !store) {
    return
  }
  store.dispatch(connectToSocket({
    url: SERVER_URL,
    token: accessToken,
  }))
}

export default reconnectWebSocketAfterAuth
